import * as React from 'react';

import { NavLinkButton, Table } from '@shared/components/bootstrap';

import { Panel as Container } from '@admin/components/helpers/panel';
import { Spinner } from '@admin/components/spinner';
import { accountPortalURL } from '@admin/config/routes';
import { client } from '@admin/libraries/apollo';
import { useOrderAttachmentsQuery } from '@admin/schema';

export const OrderAttachments: React.FC<{ orderID: string }> = ({ orderID }) => {
  const { data, loading } = useOrderAttachmentsQuery({ client, variables: { orderID } });
  const ingestedDocuments = data?.order?.ingestedDocuments;

  if (loading) {
    return <Spinner />;
  }

  if (!ingestedDocuments?.length) {
    return null;
  }

  return (
    <Container>
      <Container.Header>
        <Container.Title>Attachments</Container.Title>
      </Container.Header>
      <Container.Body>
        <h4>Ingested Documents</h4>
        <Table responsive striped>
          <tbody>
            {ingestedDocuments?.map(({ id, filename, url }) => (
              <tr key={id}>
                <td className="text-left">
                  <div>{filename}</div>
                </td>
                <td className="text-right">
                  <NavLinkButton kind="primary" target="_blank" to={`${accountPortalURL}${url}`}>
                    Download
                  </NavLinkButton>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Container.Body>
    </Container>
  );
};
